import { IMAGE_CDN_FORMATS } from "../constants/ExlyImage.constants";
import { getOptimisedImageUrl } from "./getOptimisedImageUrl";

/**
 * Fetches a low quality by appending search params format as "avif" and
 * quality as 1.
 */
export const getOptimisedLowQualityImageUrl = ({
  imageUrl,
  cdnBaseUrl,
}: {
  imageUrl: string;
  cdnBaseUrl: string;
}) =>
  getOptimisedImageUrl({
    cdnBaseUrl,
    imageUrl,
    format: IMAGE_CDN_FORMATS.AVIF,
    fetchWidth: 10,
  });
